<template>
  <div class="search__wrapper">
    <div class="search__trigger" @click.prevent="toggle($event)" @keyup="toggle($event)" tabindex="0">
      <slot name="trigger"></slot>
    </div>

    <div class="search__screen" v-show="showing" ref="search__screen">
      <div class="container">
        <div class="search__close" v-show="trigger" @click.prevent="toggle($event)" @keyup.enter="toggle($event)"
             tabindex="-1" data-tab-order="3"  aria-label="Close search modal">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
          </svg>
        </div>

        <slot>
          <form class="search__form" @submit.prevent="onFormSubmit">
<!--            <div class="filters__wrapper">-->
<!--              <div class="radio-input-wrapper">-->
<!--                <input type="radio"  v-model="searchLocation" value="this-site" tabindex="-1"-->
<!--                       data-tab-order="3" aria-label="Search this site">-->
<!--                <label for="this-site">This Site</label>-->
<!--              </div>-->
              <!--                      <div class="radio-input-wrapper">-->
              <!--                        <input type="radio"  v-model="searchLocation" value="catalog" tabindex="-1" aria-label="Search Catalog">-->
              <!--                        <label for="catalog">Catalog</label>-->
              <!--                      </div>-->
              <!--                      <div class="radio-input-wrapper">-->
              <!--                        <input type="radio"  v-model="searchLocation" value="calendar" tabindex="-1"  aria-label="Search Calendar">-->
              <!--                        <label for="calendar">Calendar</label>-->
              <!--                      </div>-->
<!--            </div>-->
            <div class="input__wrapper">
              <input type="search" class="search__input" ref="search__input" placeholder="Search …"
                     name="s"
                     title="Search for:"
                     tabindex="-1"
                     data-tab-order="1"
                     required
              >
              <button class="search__submit filled primary" type="submit" @click.prevent="onFormSubmit"
                      aria-label="Search" tabindex="-1" data-tab-order="2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd" />
                </svg>
              </button>
            </div>
          </form>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showing:        !this.trigger,
      searchLocation: 'this-site',
      tabIndex:       1,
      tabItems:       null
    };
  },

  props: {
    trigger: {
      type:    Boolean,
      default: true
    }
  },

  watch: {
    showing(isShowing) {
      if (isShowing) {
        document.body.classList.add('modal-open');
        this.$nextTick(() => {
          this.$refs.search__input.focus();
        });
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  },

  mounted() {
    this.tabItems = this.$refs.search__screen.querySelectorAll('[data-tab-order]');

    // Force tabbing to stay within the modal until it is closed
    this.$refs.search__screen.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.showing = false;
      } else if (event.key === 'Tab') {
        this.tabIndex++;
        if (this.tabIndex > this.tabItems.length) {
          this.tabIndex = 1;
        }

        for (const child of this.tabItems) {
          if (parseInt(child.getAttribute('data-tab-order')) === this.tabIndex) {
            setTimeout(function () {
              child.focus()
            }, 20)
          }
        }

      } else if (event.key === 'Tab' && event.shiftKey) {
        this.tabIndex--;
        if (this.tabIndex === 0) {
          this.tabIndex = this.tabItems.length;
        }
        for (const child of this.tabItems) {
          if (parseInt(child.getAttribute('data-tab-order')) === this.tabIndex) {
            setTimeout(function () {
              child.focus()
            }, 20)
          }
        }
      }
    });
  },

  methods: {
    toggle(event) {
      // console.log(event)
      if (event.type === "keyup") {
        if (event.key !== "Tab" && event.key !== "Shift") {

          const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
          if (alphabet.includes(event.key.toLowerCase())) {
            this.$refs.search__input.value = event.key;
          }
          this.showing = !this.showing;
        }
      } else {
        this.showing = !this.showing;
      }
    },
    onFormSubmit() {
      if (this.$refs.search__input.value) {
        if (this.searchLocation === "this-site") {
          // console.log("search this site");
          location.href = "/?s=" + this.$refs.search__input.value
        }
        // else if (this.searchLocation === "catalog") {
          // console.log("search external catalog");
          // let catalogHrefBase = "https://patmos.bibliocommons.com/v2/search?query="
          // location.href = catalogHrefBase + this.$refs.search__input.value
          // let url = catalogHrefBase + this.$refs.search__input.value
          // window.open(url, '_blank');
        // } else if (this.searchLocation === "calendar") {
          // console.log("search calendar");
          // let calendarHrefBase = "/news-events/#/events/?keyword="
          // location.href = calendarHrefBase + this.$refs.search__input.value
        // }
      }
    }
  }
}

</script>
